import { IsNumber, IsString } from 'class-validator';

export class DealFormatList {
    @IsNumber()
    formatId!: number;
    @IsNumber()
    customField!: number;
    @IsString()
    codingStr!: string;
    @IsString()
    formatDesc!: string;
}

export class DealAcquisitionList {
    @IsNumber()
    id!: number;
    @IsString()
    Text!: string;
}
